export default [
    { code: '0', name: '0%' },
    { code: '19', name: '19%' },
    { code: '21', name: '21%' },
    { code: '23', name: '23%' },
];
